export var DebtorType;
(function (DebtorType) {
    DebtorType["person"] = "P";
    DebtorType["independent"] = "S";
    DebtorType["company"] = "F";
})(DebtorType || (DebtorType = {}));
export var FoundationCode;
(function (FoundationCode) {
    FoundationCode["betalingsp\u00E5krav1p\u00E5tegning"] = "A";
    FoundationCode["betalingsp\u00E5krav2p\u00E5tegning"] = "B";
    FoundationCode["st\u00E6vning"] = "C";
    FoundationCode["fogedsag"] = "D";
    FoundationCode["dom"] = "E";
    FoundationCode["insolvens"] = "F";
    FoundationCode["konkurs"] = "I";
    FoundationCode["tvangsakkord"] = "K";
    FoundationCode["retsforlig"] = "L";
    FoundationCode["fogedretsrekv"] = "P";
    FoundationCode["offentliginberetning"] = "S";
    FoundationCode["tvangsauktion"] = "T";
    FoundationCode["tvangsauktionudl\u00E6g"] = "U";
    FoundationCode["g\u00E6ldssanering"] = "W";
    FoundationCode["skylderkl\u00E6ring"] = "Y";
    FoundationCode["forlig"] = "Z";
    FoundationCode["speciel"] = "X";
})(FoundationCode || (FoundationCode = {}));
export class RKIError extends Error {
    constructor(message) {
        super(message);
        this.name = 'RKIError';
    }
}
export const isDebtorPMV = (customer, userDetails) => {
    const companyTypeIsPMV = userDetails?.virksomhedsform && customer.isCompany
        ? ['Personligt ejet Mindre Virksomhed', 'Enkeltmandsvirksomhed'].includes(userDetails.virksomhedsform)
        : false;
    const nameIncludesV = (userDetails?.name || '').toLocaleLowerCase().indexOf(' v/') !== -1;
    return companyTypeIsPMV || nameIncludesV;
};
//# sourceMappingURL=rki.js.map